module.exports = __webpack_public_path__ + "static/media/HCLTECH_F1.e98f4ae8.txt";